import * as types from "../constants/actionTypes";

export const epicInitialState = {
    proxyRelationshipTypesPending: false,
    proxyRelationshipTypesSuccess: false,
    proxyRelationshipTypes: [],
    proxyRelationshipSetPending: false,
    proxyRelationshipSetSuccess: false,
    proxyRelationshipSetResult: null,
    proxyRelationshipGrantPending: false,
    proxyRelationshipGrantSuccess: false,
    proxyRelationshipGrantResult: null,
    proxyRelationshipGrantFailure:false,
    proxyRelationshipAcceptPending: false,
    proxyRelationshipAcceptSuccess: false,
    proxyRelationshipAcceptResult: null,
    proxyRelationshipDelete: null,
    eCheckInStatus: {},
    eCheckInStatusSuccess: false,
    eCheckInStatusPending: false,
    eCheckInStatusFailure: false,
    encryptCSN: null,
    encryptCSNSuccess: false,
    encryptCSNPending: false,
    encryptCSNFailure: false,
};

export default function epicReducer(state = epicInitialState, action) {
    switch (action.type) {

        /*case types.PROXY_RELATIONSHIP_TYPES_PENDING:
            return { ...state, proxyRelationshipTypesPending: true };
        case types.PROXY_RELATIONSHIP_TYPES_SUCCESS:
            return { ...state, proxyRelationTypesPending: false, relationTypes: action.relationTypes, proxyRelationTypesFailure: false };
        case types.PROXY_RELATIONSHIP_TYPES_FAILURE:
            return { ...state, proxyRelationshipTypesPending: false, proxyRelationshipTypesSuccess: false, relationTypes: action.relationTypes };
        */
        case types.PROXY_RELATIONSHIP_SET_PENDING:
            return { ...state, proxyRelationshipSetPending: true };
        case types.PROXY_RELATIONSHIP_SET_SUCCESS:
            return { ...state, proxyRelationshipSetPending: false, proxyRelationshipSetSuccess: true, proxyRelationshipSetResult: action.result };
        case types.PROXY_RELATIONSHIP_SET_FAILURE:
            return { ...state, proxyRelationshipSetPending: false, proxyRelationshipSetSuccess: false, proxyRelationshipSetResult: null };

        case types.PROXY_RELATIONSHIP_GRANT_PENDING:
            return { ...state, proxyRelationshipGrantPending: true, proxyRelationshipGrantFailure: false, proxyRelationshipGrantSuccess: false };
        case types.PROXY_RELATIONSHIP_GRANT_SUCCESS:
            return { ...state, proxyRelationshipGrantPending: false, proxyRelationshipGrantSuccess: true, proxyRelationshipGrantResult: action.result };
        case types.PROXY_RELATIONSHIP_GRANT_FAILURE:
            return { ...state, proxyRelationshipGrantPending: false, proxyRelationshipGrantSuccess: false, proxyRelationshipGrantFailure: true, proxyRelationshipGrantResult: null, proxyRelationshipGrantFailureMsg: action.result };

        case types.PROXY_RELATIONSHIP_ACCEPT_PENDING:
            return { ...state, proxyRelationshipAcceptPending: true };
        case types.PROXY_RELATIONSHIP_ACCEPT_SUCCESS:
            return { ...state, proxyRelationshipAcceptPending: false, proxyRelationshipAcceptSuccess: true, proxyRelationshipAcceptResult: action.result };
        case types.PROXY_RELATIONSHIP_ACCEPT_FAILURE:
            return { ...state, proxyRelationshipAcceptPending: false, proxyRelationshipAcceptSuccess: false, proxyRelationshipAcceptResult: null, proxyRelationshipAcceptFailure: action.result ? action.result : "We are not able to complete your request."};

        case types.PROXY_RELATIONSHIP_DELETE_PENDING:
            return { ...state, proxyRelationshipDelete: { waiting: true, resut: null, error: null } };
        case types.PROXY_RELATIONSHIP_DELETE_SUCCESS:
            return { ...state, proxyRelationshipDelete: { waiting: false, result: action.result, error: null } };
        case types.PROXY_RELATIONSHIP_DELETE_FAILURE:
            return { ...state, proxyRelationshipDelete: { waiting: false, result: null, error: action.error } };
        case types.GET_SPECIFIC_XEALTH_MESSAGE_PENDING:
            return { ...state, getXealthMessage: { waiting: true, messageUrl:null, error: null, conversationUrl: null}};
        case types.GET_SPECIFIC_XEALTH_MESSAGE_SUCCESS:
            return { ...state, getXealthMessage: { waiting: false, messageUrl: action.messageUrl, error: null, conversationUrl: action.conversationUrl } };
        case types.GET_SPECIFIC_XEALTH_MESSAGE_FAILURE:
            return { ...state, getXealthMessage: { waiting: false, messageUrl: null, error: true, conversationUrl: null, errorCode: action.errorCode } };

        case types.GET_ECHECKIN_STATUS_PENDING:
            return { ...state, eCheckInStatusSuccess: false, eCheckInStatusPending: true, eCheckInStatusFailure: false };
        case types.GET_ECHECKIN_STATUS_FAILURE:
            return { ...state, eCheckInStatusSuccess: false, eCheckInStatusPending: false, eCheckInStatusFailure: true };
        case types.GET_ECHECKIN_STATUS_SUCCESS:
            return { ...state, eCheckInStatus: action.eCheckInStatus, eCheckInStatusSuccess: true, eCheckInStatusPending: false, eCheckInStatusFailure: false };

        case types.GET_EPIC_ENCRYPT_CSN_PENDING:
            return { ...state, encryptCSNSuccess: false, encryptCSNPending: true, encryptCSNFailure: false };
        case types.GET_EPIC_ENCRYPT_CSN_SUCCESS:
            return { ...state, encryptCSN: action.encryptCSN, encryptCSNSuccess: true, encryptCSNPending: false, encryptCSNFailure: false };
        case types.GET_EPIC_ENCRYPT_CSN_FAILURE:
            return { ...state, encryptCSNSuccess: false, encryptCSNPending: false, encryptCSNFailure: true };
        

        default: return { ...state };
    }
}
